export const GE_ADV_WIZARD_URL_SEGMENT = "ge-adv";
